import { useEffect } from 'react'
import { useBadgeNotifications } from '../../../hooks/useBadgeNotifications'

export function BadgeNotificationSystem({ userId }: { userId: string }) {
  const { currentNotification, dismissNotification } = useBadgeNotifications(userId)

  useEffect(() => {
    if (currentNotification) {
      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        dismissNotification()
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [currentNotification, dismissNotification])

  if (!currentNotification) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="w-full max-w-md p-6 mx-4 transform border bg-slate-800 rounded-xl border-amber-500 animate-pulse">
        <div className="text-center">
          <div className="mb-4 text-6xl animate-bounce">{currentNotification.badge.icon}</div>
          <h2 className="mb-2 text-2xl font-bold text-amber-400">مبارك!</h2>
          <p className="mb-2 text-slate-100">
            حصلت على شارة <span className="font-bold text-amber-400">{currentNotification.badge.name}</span>
          </p>
          <p className="mb-4 text-sm text-slate-400">{currentNotification.badge.description}</p>

          <div className="p-3 mb-4 rounded-lg bg-slate-700">
            <div className="text-sm font-semibold text-amber-400">
              {currentNotification.badge.tier === 'bronze' && 'شارة برونزية 🥉'}
              {currentNotification.badge.tier === 'silver' && 'شارة فضية 🥈'}
              {currentNotification.badge.tier === 'gold' && 'شارة ذهبية 🥇'}
              {currentNotification.badge.tier === 'platinum' && 'شارة بلاتينية 💎'}
              {currentNotification.badge.tier === 'diamond' && 'شارة ألماس 💍'}
            </div>
            {currentNotification.badge.isExclusive && (
              <div className="mt-1 text-xs text-rose-400">شارة حصرية ⭐</div>
            )}
          </div>

          <button
            onClick={dismissNotification}
            className="w-full px-4 py-2 font-semibold text-white transition-colors rounded-lg bg-amber-500 hover:bg-amber-600"
          >
            رائع! 🎉
          </button>
        </div>
      </div>
    </div>
  )
}